(function () {
  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0700/9900/9733/files/3_7b347631-e607-4891-b47b-8c3e3491def8.png?v=1765338678';
  var FRAMES = {
    portrait: {
      canvas: { w: 650, h: 440 },
      fold: { vertical: true, pos: 325 },
      border: { x: 340, y: 12, w: 295, h: 415 },
      frame: { x: 352, y: 25, w: 270, h: 390 },
      logo: { x: 121, y: 288.5, w: 83, h: 83, rotation: 0 }
    },
    landscape: {
      canvas: { w: 440, h: 650 },
      fold: { vertical: false, pos: 325 },
      border: { x: 12, y: 340, w: 415, h: 295 },
      frame: { x: 25, y: 352, w: 390, h: 270 },
      logo: { x: 178.5, y: 39.75, w: 83, h: 83, rotation: 180 }
    }
  };
  var COLORS = { white: '#FFFFFF', black: '#000000', terracotta: '#D37A42', sage: '#A7C4A0', gold: '#DAAB75', slate: '#6E7C8C' };
  var FONT_OPTIONS = ['Playfair Display', 'Poppins', 'Montserrat', 'Raleway', 'Quicksand', 'Josefin Sans', 'Oswald', 'Helvetica', 'Georgia', 'Merriweather', 'Lora', 'Cormorant Garamond', 'Roboto Slab', 'Abril Fatface', 'Bebas Neue', 'Courier New', 'Dancing Script', 'Pacifico', 'Great Vibes', 'Caveat'];

  var el = function (id) { return document.getElementById(id); };
  var fc = null, pv = null;
  var history = [], historyIndex = -1, suppressHistory = false;
  var guideObjs = [];
  var clipboard = null;
  var state = {
    orientation: 'portrait',
    view: 'design',
    zoom: 1,
    ratioLocked: true,
    foldAngle: 130
  };

  function frame() { return FRAMES[state.orientation]; }
  function getActive() { return fc.getActiveObject(); }
  function getCustomerObjects() { return fc.getObjects().filter(function (o) { return !o.lockedEl && !o.isGuide; }); }
  function makeClip() { var F = frame(); return new fabric.Rect({ left: F.frame.x, top: F.frame.y, width: F.frame.w, height: F.frame.h, absolutePositioned: true }); }
  function clampLayer(o) {
    var objs = fc.getObjects();
    var lockedCount = objs.filter(function (x) { return x.lockedEl; }).length;
    var idx = objs.indexOf(o);
    if (idx < lockedCount) fc.moveTo(o, lockedCount);
  }

  function buildLockedLayout(orientation, initial) {
    var F = FRAMES[orientation];
    fc.clear();
    fc.setDimensions({ width: F.canvas.w, height: F.canvas.h });
    var bg = new fabric.Rect({ left: 0, top: 0, width: F.canvas.w, height: F.canvas.h, fill: '#FFFFFF', selectable: false, evented: false, lockedEl: true, hoverCursor: 'default' });
    var border = new fabric.Rect({ left: F.border.x, top: F.border.y, width: F.border.w, height: F.border.h, fill: 'transparent', stroke: '#000000', strokeWidth: 3, selectable: false, evented: false, lockedEl: true, hoverCursor: 'default' });
    var frameBg = new fabric.Rect({ left: F.frame.x, top: F.frame.y, width: F.frame.w, height: F.frame.h, fill: '#FFFFFF', selectable: false, evented: false, lockedEl: true, hoverCursor: 'default' });
    fc.add(bg, border, frameBg);
    fc.renderAll();
    fabric.Image.fromURL(LOGO_URL, function (img) {
      var scale = F.logo.w / img.width;
      img.set({
        left: F.logo.x + F.logo.w / 2, top: F.logo.y + F.logo.h / 2, originX: 'center', originY: 'center',
        scaleX: scale, scaleY: scale, angle: F.logo.rotation,
        selectable: false, evented: false, lockedEl: true, hoverCursor: 'default'
      });
      fc.add(img);
      fc.moveTo(img, fc.getObjects().filter(function (x) { return x.lockedEl; }).length - 1);
      fc.renderAll();
    }, { crossOrigin: 'anonymous' });
    updateGuides();
    if (!initial) clearSelectionUI();
  }

  function updateGuides() {
    var F = frame();
    var gf = el('guideFrame'), gd = el('guideFold');
    gf.style.left = F.frame.x + 'px'; gf.style.top = F.frame.y + 'px'; gf.style.width = F.frame.w + 'px'; gf.style.height = F.frame.h + 'px';
    if (F.fold.vertical) {
      gd.style.left = F.fold.pos + 'px'; gd.style.top = '0'; gd.style.width = '0'; gd.style.height = F.canvas.h + 'px';
      gd.style.borderLeft = '2px dashed #6E7C8C'; gd.style.borderTop = 'none';
    } else {
      gd.style.left = '0'; gd.style.top = F.fold.pos + 'px'; gd.style.width = F.canvas.w + 'px'; gd.style.height = '0';
      gd.style.borderTop = '2px dashed #6E7C8C'; gd.style.borderLeft = 'none';
    }
  }

  function clearSelectionUI() {
    el('textToolbar').style.display = 'none';
    el('imageToolbar').style.display = 'none';
    closePopovers();
  }
  function onSelect(obj) {
    if (!obj || obj.lockedEl) { clearSelectionUI(); return; }
    closePopovers();
    if (obj.type === 'textbox') {
      el('textToolbar').style.display = 'flex';
      el('imageToolbar').style.display = 'none';
      el('fontSelect').value = obj.fontFamily || 'Poppins';
      el('fontSizeInput').value = obj.fontSize || 24;
      el('colorTrigger').style.background = obj.fill || '#000000';
      el('btnBold').style.background = obj.fontWeight === 'bold' ? '#000000' : '#FFFFFF';
      el('btnBold').style.color = obj.fontWeight === 'bold' ? '#FFFFFF' : '#000000';
      el('btnItalic').style.background = obj.fontStyle === 'italic' ? '#000000' : '#FFFFFF';
      el('btnItalic').style.color = obj.fontStyle === 'italic' ? '#FFFFFF' : '#000000';
      el('btnUnderline').style.background = obj.underline ? '#000000' : '#FFFFFF';
      el('btnUnderline').style.color = obj.underline ? '#FFFFFF' : '#000000';
      el('alignTrigger').textContent = 'Align: ' + ({ left: 'L', center: 'C', right: 'R' }[obj.textAlign] || 'L');
      updateLockBtn(el('tLock'), obj);
    } else {
      el('imageToolbar').style.display = 'flex';
      el('textToolbar').style.display = 'none';
      el('opacityInput').value = obj.opacity != null ? obj.opacity : 1;
      el('iBW').style.background = (obj.filters && obj.filters.length) ? '#000000' : '#FFFFFF';
      el('iBW').style.color = (obj.filters && obj.filters.length) ? '#FFFFFF' : '#000000';
      updateLockBtn(el('iLock'), obj);
    }
    updatePositionFields();
  }
  function updateLockBtn(btn, obj) {
    var locked = !!(obj && obj.lockMovementX);
    btn.textContent = locked ? 'Unlock' : 'Lock';
    btn.style.background = locked ? '#000000' : '#FFFFFF';
    btn.style.color = locked ? '#FFFFFF' : '#000000';
  }

  function updateActiveText(props) {
    var o = getActive(); if (!o) return;
    o.set(props); fc.renderAll();
    onSelect(o); pushHistory();
  }

  function pushHistory() {
    if (suppressHistory || !fc) return;
    var json = JSON.stringify(fc.toJSON(['lockedEl', 'selectable', 'evented']));
    history = history.slice(0, historyIndex + 1);
    history.push(json);
    if (history.length > 25) history.shift(); else historyIndex++;
    historyIndex = history.length - 1;
    updateHistoryButtons();
  }
  function updateHistoryButtons() {
    el('btnUndo').disabled = historyIndex <= 0;
    el('btnUndo').style.opacity = historyIndex <= 0 ? 0.4 : 1;
    el('btnRedo').disabled = historyIndex >= history.length - 1;
    el('btnRedo').style.opacity = historyIndex >= history.length - 1 ? 0.4 : 1;
  }
  function resetHistory() { history = []; historyIndex = -1; suppressHistory = false; pushHistory(); }
  function loadHistoryState() {
    suppressHistory = true;
    fc.loadFromJSON(history[historyIndex], function () {
      fc.renderAll(); suppressHistory = false;
      updateHistoryButtons(); clearSelectionUI();
    });
  }
  function undo() { if (historyIndex <= 0) return; historyIndex--; loadHistoryState(); }
  function redo() { if (historyIndex >= history.length - 1) return; historyIndex++; loadHistoryState(); }

  function handleSnap(obj) {
    var F = frame(); var THRESH = 6;
    clearGuideLines();
    var br = obj.getBoundingRect(true);
    var left = br.left, right = br.left + br.width, cx = br.left + br.width / 2;
    var top = br.top, bottom = br.top + br.height, cy = br.top + br.height / 2;
    var vLines = [F.frame.x, F.frame.x + F.frame.w, F.frame.x + F.frame.w / 2];
    var hLines = [F.frame.y, F.frame.y + F.frame.h, F.frame.y + F.frame.h / 2];
    if (F.fold.vertical) vLines.push(F.fold.pos); else hLines.push(F.fold.pos);
    getCustomerObjects().forEach(function (o) {
      if (o === obj) return;
      var b = o.getBoundingRect(true);
      vLines.push(b.left, b.left + b.width, b.left + b.width / 2);
      hLines.push(b.top, b.top + b.height, b.top + b.height / 2);
    });
    var dx = null, dy = null, snapX = null, snapY = null;
    [[left, 0], [right, br.width], [cx, br.width / 2]].forEach(function (pair) {
      vLines.forEach(function (v) { if (dx === null && Math.abs(pair[0] - v) < THRESH) { dx = v - pair[0]; snapX = v; } });
    });
    [[top, 0], [bottom, br.height], [cy, br.height / 2]].forEach(function (pair) {
      hLines.forEach(function (v) { if (dy === null && Math.abs(pair[0] - v) < THRESH) { dy = v - pair[0]; snapY = v; } });
    });
    if (dx !== null) obj.left += dx;
    if (dy !== null) obj.top += dy;
    if (snapX !== null) addGuideLine(new fabric.Line([snapX, 0, snapX, F.canvas.h], { stroke: '#D37A42', strokeDashArray: [4, 4], selectable: false, evented: false, isGuide: true }));
    if (snapY !== null) addGuideLine(new fabric.Line([0, snapY, F.canvas.w, snapY], { stroke: '#D37A42', strokeDashArray: [4, 4], selectable: false, evented: false, isGuide: true }));
  }
  function addGuideLine(line) { guideObjs.push(line); fc.add(line); }
  function clearGuideLines() { guideObjs.forEach(function (l) { fc.remove(l); }); guideObjs = []; }
  function handleRotationSnap(obj) {
    var a = ((obj.angle % 360) + 360) % 360;
    var nearest = Math.round(a / 90) * 90;
    if (Math.abs(a - nearest) < 5) obj.rotate(nearest % 360);
  }

  function updatePositionFields() {
    var o = getActive();
    var F = frame();
    if (!o) { el('posW').value = ''; el('posH').value = ''; el('posX').value = ''; el('posY').value = ''; el('posRotate').value = ''; return; }
    var br = o.getBoundingRect(true);
    el('posW').value = Math.round(br.width);
    el('posH').value = Math.round(br.height);
    el('posX').value = Math.round(br.left - F.frame.x);
    el('posY').value = Math.round(br.top - F.frame.y);
    el('posRotate').value = Math.round(o.angle || 0);
  }
  function openPositionPopover(btn) {
    var panel = el('positionPanel');
    if (panel.style.display === 'flex') { panel.style.display = 'none'; return; }
    closePopovers();
    var r = btn.getBoundingClientRect();
    var left = Math.min(Math.max(8, r.left), window.innerWidth - 266);
    panel.style.top = (r.bottom + 6) + 'px';
    panel.style.left = left + 'px';
    panel.style.display = 'flex';
    updatePositionFields();
  }
  function closePopovers() {
    el('positionPanel').style.display = 'none';
    el('colorPopover').style.display = 'none';
    el('alignPopover').style.display = 'none';
    el('contextMenu').style.display = 'none';
    el('contextMenuOverlay').style.display = 'none';
  }

  function alignToFrame(edge) {
    var o = getActive(); if (!o) return;
    var F = frame();
    var br = o.getBoundingRect(true);
    var dx = 0, dy = 0;
    if (edge === 'left') dx = F.frame.x - br.left;
    else if (edge === 'right') dx = (F.frame.x + F.frame.w) - (br.left + br.width);
    else if (edge === 'centerX') dx = (F.frame.x + F.frame.w / 2) - (br.left + br.width / 2);
    else if (edge === 'top') dy = F.frame.y - br.top;
    else if (edge === 'bottom') dy = (F.frame.y + F.frame.h) - (br.top + br.height);
    else if (edge === 'centerY') dy = (F.frame.y + F.frame.h / 2) - (br.top + br.height / 2);
    o.left += dx; o.top += dy; o.setCoords(); fc.renderAll(); updatePositionFields(); pushHistory();
  }

  function onCanvasContextMenu(e) {
    e.preventDefault();
    var target = fc.findTarget(e, false);
    if (target && !target.lockedEl) { fc.setActiveObject(target); fc.renderAll(); onSelect(target); }
    else if (!target) { fc.discardActiveObject(); fc.renderAll(); clearSelectionUI(); }
    buildContextMenu(target && !target.lockedEl ? target : null);
    var left = Math.min(Math.max(8, e.clientX), window.innerWidth - 206);
    var top = Math.min(Math.max(8, e.clientY), window.innerHeight - 60);
    var menu = el('contextMenu');
    menu.style.left = left + 'px'; menu.style.top = top + 'px';
    menu.style.display = 'block';
    el('contextMenuOverlay').style.display = 'block';
  }
  function buildContextMenu(activeObj) {
    var menu = el('contextMenu');
    menu.innerHTML = '';
    function addItem(label, fn, disabled) {
      var b = document.createElement('button');
      b.textContent = label;
      b.className = 'hover-menu';
      b.style.cssText = 'display:block;width:100%;text-align:left;height:34px;padding:0 10px;border:none;background:none;border-radius:6px;font-size:13px;font-family:Poppins,sans-serif;cursor:' + (disabled ? 'default' : 'pointer') + ';color:#000000;opacity:' + (disabled ? 0.4 : 1);
      if (!disabled) b.addEventListener('click', function () { fn(); closePopovers(); });
      menu.appendChild(b);
    }
    function addDivider() {
      var d = document.createElement('div');
      d.style.cssText = 'height:1px;background:rgba(110,124,140,0.2);margin:4px 6px';
      menu.appendChild(d);
    }
    var hasSel = !!activeObj;
    var isImg = hasSel && activeObj.type === 'image';
    addItem('Copy', copySelected, !hasSel);
    addItem('Paste', pasteClipboard, !clipboard);
    if (hasSel) {
      addItem('Duplicate', duplicateActive);
      addItem('Delete', deleteActive);
      addDivider();
      addItem('Bring Forward', layerForward);
      addItem('Send Backward', layerBackward);
      addItem('Bring to Front', bringToFront);
      addItem('Send to Back', sendToBack);
      if (isImg) {
        addDivider();
        addItem('Set as Background', setAsBackground);
        addItem('Flip Horizontal', flipHorizontal);
        addItem('Flip Vertical', flipVertical);
        addItem('Black & White', toggleBW);
      }
      addDivider();
      addItem('Align Left', function () { alignToFrame('left'); });
      addItem('Align Center', function () { alignToFrame('centerX'); });
      addItem('Align Right', function () { alignToFrame('right'); });
      addItem('Align Top', function () { alignToFrame('top'); });
      addItem('Align Middle', function () { alignToFrame('centerY'); });
      addItem('Align Bottom', function () { alignToFrame('bottom'); });
      addDivider();
      addItem(activeObj.lockMovementX ? 'Unlock' : 'Lock', toggleLock);
    }
  }
  function copySelected() { var o = getActive(); if (!o) return; o.clone(function (c) { clipboard = c; }); }
  function pasteClipboard() {
    if (!clipboard) return;
    clipboard.clone(function (c) {
      c.set({ left: (c.left || 0) + 16, top: (c.top || 0) + 16, clipPath: makeClip() });
      fc.add(c); fc.setActiveObject(c); fc.renderAll(); onSelect(c); pushHistory();
    });
  }

  function layerForward() { var o = getActive(); if (!o) return; o.bringForward(); clampLayer(o); fc.renderAll(); pushHistory(); }
  function layerBackward() { var o = getActive(); if (!o) return; o.sendBackwards(); clampLayer(o); fc.renderAll(); pushHistory(); }
  function bringToFront() { var o = getActive(); if (!o) return; o.bringToFront(); fc.renderAll(); pushHistory(); }
  function sendToBack() { var o = getActive(); if (!o) return; o.sendToBack(); clampLayer(o); fc.renderAll(); pushHistory(); }
  function setAsBackground() {
    var o = getActive(); if (!o || o.type !== 'image') return;
    var F = frame();
    var scale = Math.max(F.frame.w / o.width, F.frame.h / o.height);
    o.set({ scaleX: scale, scaleY: scale, left: F.frame.x + F.frame.w / 2, top: F.frame.y + F.frame.h / 2, originX: 'center', originY: 'center', angle: 0, flipX: false, flipY: false });
    o.setCoords();
    o.sendToBack(); clampLayer(o);
    fc.renderAll(); updatePositionFields(); pushHistory();
  }
  function toggleLock() {
    var o = getActive(); if (!o) return;
    var locked = !o.lockMovementX;
    o.set({ lockMovementX: locked, lockMovementY: locked, lockScalingX: locked, lockScalingY: locked, lockRotation: locked, hasControls: !locked, hoverCursor: locked ? 'default' : 'move' });
    fc.renderAll();
    updateLockBtn(o.type === 'textbox' ? el('tLock') : el('iLock'), o);
    pushHistory();
  }
  function duplicateActive() {
    var o = getActive(); if (!o) return;
    o.clone(function (cloned) {
      cloned.set({ left: o.left + 16, top: o.top + 16, clipPath: makeClip() });
      fc.add(cloned); fc.setActiveObject(cloned); fc.renderAll();
      onSelect(cloned); pushHistory();
    });
  }
  function deleteActive() { var o = getActive(); if (!o) return; fc.remove(o); fc.discardActiveObject(); fc.renderAll(); clearSelectionUI(); pushHistory(); }
  function addText() {
    var F = frame();
    var t = new fabric.Textbox('Your text here', {
      left: F.frame.x + F.frame.w / 2 - 90, top: F.frame.y + F.frame.h / 2 - 16, width: 180,
      fontFamily: 'Poppins', fontSize: 24, fill: '#000000', textAlign: 'left', clipPath: makeClip()
    });
    fc.add(t); fc.setActiveObject(t); fc.renderAll(); onSelect(t); pushHistory();
  }
  function flipHorizontal() { var o = getActive(); if (!o) return; o.set('flipX', !o.flipX); fc.renderAll(); pushHistory(); }
  function flipVertical() { var o = getActive(); if (!o) return; o.set('flipY', !o.flipY); fc.renderAll(); pushHistory(); }
  function toggleBW() {
    var o = getActive(); if (!o || !o.filters) return;
    if (o.filters.length) { o.filters = []; } else { o.filters = [new fabric.Image.filters.Grayscale()]; }
    o.applyFilters(); fc.renderAll();
    el('iBW').style.background = o.filters.length ? '#000000' : '#FFFFFF';
    el('iBW').style.color = o.filters.length ? '#FFFFFF' : '#000000';
    pushHistory();
  }

  function handleFileChange(e) {
    var file = e.target.files && e.target.files[0]; if (!file) return;
    var reader = new FileReader();
    reader.onload = function (ev) {
      fabric.Image.fromURL(ev.target.result, function (img) {
        var F = frame();
        var scale = Math.min((F.frame.w * 0.9) / img.width, (F.frame.h * 0.9) / img.height, 1);
        img.set({
          left: F.frame.x + F.frame.w / 2, top: F.frame.y + F.frame.h / 2, originX: 'center', originY: 'center',
          scaleX: scale, scaleY: scale, clipPath: makeClip()
        });
        fc.add(img); fc.setActiveObject(img); fc.renderAll(); onSelect(img); pushHistory();
      });
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  }

  function setOrientation(o) {
    if (o === state.orientation) return;
    if (getCustomerObjects().length > 0) {
      if (!window.confirm('Switching orientation will clear your current design. Continue?')) return;
    }
    state.orientation = o;
    updateOrientationTabs();
    buildLockedLayout(o, false);
    resetHistory();
  }
  function updateOrientationTabs() {
    var p = state.orientation === 'portrait';
    el('btnPortrait').style.background = p ? '#000000' : 'transparent';
    el('btnPortrait').style.color = p ? '#FFFFFF' : '#000000';
    el('btnLandscape').style.background = !p ? '#000000' : 'transparent';
    el('btnLandscape').style.color = !p ? '#FFFFFF' : '#000000';
    var F = frame();
    el('canvasWrap').style.width = F.canvas.w + 'px';
    el('canvasWrap').style.height = F.canvas.h + 'px';
  }
  function clearDesign() {
    var objs = getCustomerObjects(); if (objs.length === 0) return;
    if (!window.confirm('Clear your current design? This cannot be undone.')) return;
    objs.forEach(function (o) { fc.remove(o); });
    fc.discardActiveObject(); fc.renderAll();
    clearSelectionUI(); pushHistory();
  }
  function resetAll() {
    if (!window.confirm('Reset everything (design and orientation)? This cannot be undone.')) return;
    state.orientation = 'portrait'; state.zoom = 1;
    updateOrientationTabs(); applyZoom();
    buildLockedLayout('portrait', false); resetHistory();
  }
  function applyZoom() {
    el('canvasWrap').style.transform = 'scale(' + state.zoom + ')';
    el('zoomPct').textContent = Math.round(state.zoom * 100) + '%';
  }
  function zoomIn() { state.zoom = Math.min(2, +(state.zoom + 0.1).toFixed(2)); applyZoom(); }
  function zoomOut() { state.zoom = Math.max(0.25, +(state.zoom - 0.1).toFixed(2)); applyZoom(); }
  function zoomReset() { state.zoom = 1; applyZoom(); }

  function updateViewTabs() {
    var d = state.view === 'design';
    el('btnDesignView').style.background = d ? '#000000' : 'transparent';
    el('btnDesignView').style.color = d ? '#FFFFFF' : '#000000';
    el('btnPreviewView').style.background = !d ? '#000000' : 'transparent';
    el('btnPreviewView').style.color = !d ? '#FFFFFF' : '#000000';
    el('designView').style.display = d ? 'flex' : 'none';
    el('previewView').style.display = !d ? 'block' : 'none';
  }
  function showDesignView() { state.view = 'design'; updateViewTabs(); }
  function showPreviewView() {
    fc.discardActiveObject(); fc.renderAll();
    var dataURL = fc.toDataURL({ format: 'png', multiplier: 2 });
    state.view = 'preview'; updateViewTabs(); clearSelectionUI();
    requestAnimationFrame(function () { renderPreview3D(dataURL); });
  }

  function setupPreviewScene(canvas) {
    var THREE = window.THREE;
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(32, 1, 0.05, 100);
    scene.add(new THREE.HemisphereLight(0xffffff, 0x777777, 1.15));
    var dir = new THREE.DirectionalLight(0xffffff, 0.55); dir.position.set(2, 4, 3); scene.add(dir);
    var hinge = new THREE.Group(); scene.add(hinge);
    var leftPivot = new THREE.Group(); var rightPivot = new THREE.Group();
    hinge.add(leftPivot); hinge.add(rightPivot);
    pv = {
      renderer: renderer, scene: scene, camera: camera, hinge: hinge, leftPivot: leftPivot, rightPivot: rightPivot,
      leftMesh: null, rightMesh: null, orientation: null, vertical: true, foldPosFrac: 0.5,
      dragging: false, lastX: 0, lastY: 0, camTheta: 0.35, camPhi: 1.15, camDist: 6
    };
    canvas.addEventListener('pointerdown', onPvPointerDown);
    window.addEventListener('pointermove', onPvPointerMove);
    window.addEventListener('pointerup', onPvPointerUp);
    canvas.addEventListener('wheel', onPvWheel, { passive: false });
    updateCamera();
  }
  function buildPreviewGeometry() {
    var F = frame();
    if (pv.orientation === state.orientation && pv.leftMesh) return;
    var THREE = window.THREE;
    if (pv.leftMesh) { pv.leftPivot.remove(pv.leftMesh); pv.leftMesh.geometry.dispose(); pv.leftMesh.material.forEach(function (m) { if (m.map) m.map.dispose(); m.dispose(); }); }
    if (pv.rightMesh) { pv.rightPivot.remove(pv.rightMesh); pv.rightMesh.geometry.dispose(); pv.rightMesh.material.forEach(function (m) { if (m.map) m.map.dispose(); m.dispose(); }); }
    var S = 1 / 200;
    function makeMaterials() {
      var edge = new THREE.MeshStandardMaterial({ color: 0xfbfaf7, roughness: 0.9 });
      var back = new THREE.MeshStandardMaterial({ color: 0xfbfaf7, roughness: 0.9 });
      var front = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.85 });
      return [edge, edge, edge, edge, front, back];
    }
    var depth = 3 * S;
    if (F.fold.vertical) {
      pv.vertical = true;
      var wA = F.fold.pos, wB = F.canvas.w - F.fold.pos, h = F.canvas.h;
      pv.leftMesh = new THREE.Mesh(new THREE.BoxGeometry(wA * S, h * S, depth), makeMaterials());
      pv.leftMesh.position.x = -(wA * S) / 2;
      pv.rightMesh = new THREE.Mesh(new THREE.BoxGeometry(wB * S, h * S, depth), makeMaterials());
      pv.rightMesh.position.x = (wB * S) / 2;
      pv.foldPosFrac = F.fold.pos / F.canvas.w;
    } else {
      pv.vertical = false;
      var w = F.canvas.w, hA = F.fold.pos, hB = F.canvas.h - F.fold.pos;
      pv.leftMesh = new THREE.Mesh(new THREE.BoxGeometry(w * S, hA * S, depth), makeMaterials());
      pv.leftMesh.position.y = (hA * S) / 2;
      pv.rightMesh = new THREE.Mesh(new THREE.BoxGeometry(w * S, hB * S, depth), makeMaterials());
      pv.rightMesh.position.y = -(hB * S) / 2;
      pv.foldPosFrac = F.fold.pos / F.canvas.h;
    }
    pv.leftPivot.add(pv.leftMesh); pv.rightPivot.add(pv.rightMesh);
    pv.orientation = state.orientation;
    pv.camDist = Math.max(F.canvas.w, F.canvas.h) * S * 2.1;
  }
  function loadPreviewTexture(dataURL) {
    var THREE = window.THREE;
    new THREE.TextureLoader().load(dataURL, function (tex) {
      tex.wrapS = THREE.ClampToEdgeWrapping; tex.wrapT = THREE.ClampToEdgeWrapping;
      var texA = tex; var texB = tex.clone(); texB.needsUpdate = true;
      if (pv.vertical) {
        texA.repeat.set(pv.foldPosFrac, 1); texA.offset.set(0, 0);
        texB.repeat.set(1 - pv.foldPosFrac, 1); texB.offset.set(pv.foldPosFrac, 0);
      } else {
        texA.repeat.set(1, pv.foldPosFrac); texA.offset.set(0, 1 - pv.foldPosFrac);
        texB.repeat.set(1, 1 - pv.foldPosFrac); texB.offset.set(0, 0);
      }
      var leftFront = pv.leftMesh.material[4], rightFront = pv.rightMesh.material[4];
      if (leftFront.map) leftFront.map.dispose();
      if (rightFront.map) rightFront.map.dispose();
      leftFront.map = texA; leftFront.needsUpdate = true;
      rightFront.map = texB; rightFront.needsUpdate = true;
      renderPvFrame();
    });
  }
  function applyFoldAngle() {
    var THREE = window.THREE; if (!pv) return;
    var half = THREE.MathUtils.degToRad((180 - state.foldAngle) / 2);
    if (pv.vertical) { pv.leftPivot.rotation.set(0, -half, 0); pv.rightPivot.rotation.set(0, half, 0); }
    else { pv.leftPivot.rotation.set(-half, 0, 0); pv.rightPivot.rotation.set(half, 0, 0); }
  }
  function updateCamera() {
    if (!pv) return;
    var r = pv.camDist;
    pv.camera.position.set(r * Math.sin(pv.camPhi) * Math.sin(pv.camTheta), r * Math.cos(pv.camPhi), r * Math.sin(pv.camPhi) * Math.cos(pv.camTheta));
    pv.camera.lookAt(0, 0, 0);
  }
  function renderPvFrame() { if (pv) pv.renderer.render(pv.scene, pv.camera); }
  function resizePreviewRenderer() {
    var canvas = el('preview3d');
    if (!pv || !canvas) return;
    var w = canvas.clientWidth || 600, h = canvas.clientHeight || 400;
    pv.renderer.setSize(w, h, false);
    pv.camera.aspect = w / h; pv.camera.updateProjectionMatrix();
  }
  function renderPreview3D(dataURL) {
    var canvas = el('preview3d'); if (!canvas || !window.THREE) return;
    if (!pv) setupPreviewScene(canvas);
    buildPreviewGeometry();
    resizePreviewRenderer();
    applyFoldAngle();
    updateCamera();
    loadPreviewTexture(dataURL);
    renderPvFrame();
  }
  function onPvPointerDown(e) { if (pv) { pv.dragging = true; pv.lastX = e.clientX; pv.lastY = e.clientY; } }
  function onPvPointerMove(e) {
    if (!pv || !pv.dragging) return;
    var dx = e.clientX - pv.lastX, dy = e.clientY - pv.lastY;
    pv.lastX = e.clientX; pv.lastY = e.clientY;
    pv.camTheta -= dx * 0.01;
    pv.camPhi = Math.min(Math.max(pv.camPhi - dy * 0.01, 0.35), Math.PI - 0.35);
    updateCamera(); renderPvFrame();
  }
  function onPvPointerUp() { if (pv) pv.dragging = false; }
  function onPvWheel(e) {
    if (!pv) return; e.preventDefault();
    pv.camDist = Math.min(Math.max(pv.camDist + (e.deltaY > 0 ? pv.camDist * 0.08 : -pv.camDist * 0.08), 0.5), 30);
    updateCamera(); renderPvFrame();
  }
  function resetPreviewView() {
    if (pv) { pv.camTheta = 0.35; pv.camPhi = 1.15; buildPreviewGeometry(); pv.camDist = Math.max(0.1, pv.camDist); updateCamera(); }
    state.foldAngle = 130; el('foldAngleInput').value = 130;
    applyFoldAngle(); renderPvFrame();
  }

  function exportDesign() {
    fc.discardActiveObject(); fc.renderAll();
    var F = frame();
    var dataURL = fc.toDataURL({ format: 'png', left: F.frame.x, top: F.frame.y, width: F.frame.w, height: F.frame.h, multiplier: 3 });
    var link = document.createElement('a');
    link.href = dataURL; link.download = 'vinylhut-card-design.png';
    document.body.appendChild(link); link.click(); document.body.removeChild(link);
    clearSelectionUI();
  }
  function getPrintReadyDataURL() {
    fc.discardActiveObject(); fc.renderAll();
    var F = frame();
    return fc.toDataURL({ format: 'png', left: F.frame.x, top: F.frame.y, width: F.frame.w, height: F.frame.h, multiplier: 3 });
  }
  window.getCardDesignPrintReadyDataURL = getPrintReadyDataURL;
  function addToCart() { window.alert('This connects to Shopify checkout in the live store.'); }

  function populateFontSelect() {
    var sel = el('fontSelect');
    FONT_OPTIONS.forEach(function (f) {
      var o = document.createElement('option');
      o.value = f; o.textContent = f; o.style.fontFamily = "'" + f + "',sans-serif";
      sel.appendChild(o);
    });
  }
  function populateSwatches() {
    var row = el('swatchRow');
    Object.keys(COLORS).forEach(function (name) {
      var hex = COLORS[name];
      var b = document.createElement('button');
      b.title = name;
      b.style.cssText = 'width:22px;height:22px;border-radius:50%;background:' + hex + ';border:1px solid rgba(110,124,140,0.4);cursor:pointer;padding:0';
      b.addEventListener('click', function () { updateActiveText({ fill: hex }); el('colorTrigger').style.background = hex; });
      row.appendChild(b);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var canvasEl = el('fabricCanvas');
    fc = new fabric.Canvas(canvasEl, { selection: true, preserveObjectStacking: true });
    populateFontSelect();
    populateSwatches();
    buildLockedLayout(state.orientation, true);
    updateOrientationTabs();
    updateViewTabs();

    fc.on('selection:created', function (e) { onSelect(e.selected && e.selected[0]); });
    fc.on('selection:updated', function (e) { onSelect(e.selected && e.selected[0]); });
    fc.on('selection:cleared', clearSelectionUI);
    fc.on('object:moving', function (e) { handleSnap(e.target); });
    fc.on('object:rotating', function (e) { handleRotationSnap(e.target); });
    fc.on('object:modified', function () { clearGuideLines(); pushHistory(); });
    fc.on('mouse:up', clearGuideLines);
    fc.on('object:added', function (e) { if (!suppressHistory && e.target && !e.target.isGuide && !e.target.lockedEl) pushHistory(); });
    fc.on('object:removed', function (e) { if (!suppressHistory && e.target && !e.target.isGuide) pushHistory(); });
    fc.upperCanvasEl.addEventListener('contextmenu', onCanvasContextMenu);
    resetHistory();

    window.addEventListener('resize', function () { if (state.view === 'preview') { resizePreviewRenderer(); renderPvFrame(); } });

    el('btnUndo').addEventListener('click', undo);
    el('btnRedo').addEventListener('click', redo);
    el('btnPortrait').addEventListener('click', function () { setOrientation('portrait'); });
    el('btnLandscape').addEventListener('click', function () { setOrientation('landscape'); });
    el('btnZoomOut').addEventListener('click', zoomOut);
    el('btnZoomIn').addEventListener('click', zoomIn);
    el('btnZoomReset').addEventListener('click', zoomReset);
    el('btnDesignView').addEventListener('click', showDesignView);
    el('btnPreviewView').addEventListener('click', showPreviewView);
    el('btnSaveCopy').addEventListener('click', exportDesign);
    el('btnAddToCart').addEventListener('click', addToCart);
    el('btnAddText').addEventListener('click', addText);
    el('fileInput').addEventListener('change', handleFileChange);
    el('btnClearDesign').addEventListener('click', clearDesign);
    el('btnResetAll').addEventListener('click', resetAll);
    el('btnResetPreview').addEventListener('click', resetPreviewView);
    el('foldAngleInput').addEventListener('input', function (e) { state.foldAngle = parseInt(e.target.value, 10); applyFoldAngle(); renderPvFrame(); });

    el('fontSelect').addEventListener('change', function (e) { updateActiveText({ fontFamily: e.target.value }); });
    el('fontSizeInput').addEventListener('change', function (e) { updateActiveText({ fontSize: parseInt(e.target.value, 10) || 8 }); });
    el('colorTrigger').addEventListener('click', function () { var p = el('colorPopover'); var open = p.style.display === 'flex'; closePopovers(); p.style.display = open ? 'none' : 'flex'; });
    el('customColor').addEventListener('input', function (e) { updateActiveText({ fill: e.target.value }); el('colorTrigger').style.background = e.target.value; });
    el('btnBold').addEventListener('click', function () { var o = getActive(); if (!o) return; updateActiveText({ fontWeight: o.fontWeight === 'bold' ? 'normal' : 'bold' }); });
    el('btnItalic').addEventListener('click', function () { var o = getActive(); if (!o) return; updateActiveText({ fontStyle: o.fontStyle === 'italic' ? 'normal' : 'italic' }); });
    el('btnUnderline').addEventListener('click', function () { var o = getActive(); if (!o) return; updateActiveText({ underline: !o.underline }); });
    el('alignTrigger').addEventListener('click', function () { var p = el('alignPopover'); var open = p.style.display === 'flex'; closePopovers(); p.style.display = open ? 'none' : 'flex'; });
    Array.prototype.forEach.call(document.querySelectorAll('#alignPopover [data-align]'), function (b) {
      b.addEventListener('click', function () { updateActiveText({ textAlign: b.getAttribute('data-align') }); el('alignTrigger').textContent = 'Align: ' + b.textContent; closePopovers(); });
    });
    el('tLayerForward').addEventListener('click', layerForward);
    el('tLayerBackward').addEventListener('click', layerBackward);
    el('tBringFront').addEventListener('click', bringToFront);
    el('tSendBack').addEventListener('click', sendToBack);
    el('tDuplicate').addEventListener('click', duplicateActive);
    el('tLock').addEventListener('click', toggleLock);
    el('tPosition').addEventListener('click', function () { openPositionPopover(el('tPosition')); });
    el('tDelete').addEventListener('click', deleteActive);

    el('opacityInput').addEventListener('input', function (e) {
      var o = getActive(); if (!o) return;
      o.set('opacity', parseFloat(e.target.value)); fc.renderAll(); pushHistory();
    });
    el('iFlipH').addEventListener('click', flipHorizontal);
    el('iFlipV').addEventListener('click', flipVertical);
    el('iBW').addEventListener('click', toggleBW);
    el('iSetBg').addEventListener('click', setAsBackground);
    el('iLayerForward').addEventListener('click', layerForward);
    el('iLayerBackward').addEventListener('click', layerBackward);
    el('iBringFront').addEventListener('click', bringToFront);
    el('iSendBack').addEventListener('click', sendToBack);
    el('iDuplicate').addEventListener('click', duplicateActive);
    el('iLock').addEventListener('click', toggleLock);
    el('iPosition').addEventListener('click', function () { openPositionPopover(el('iPosition')); });
    el('iDelete').addEventListener('click', deleteActive);

    Array.prototype.forEach.call(document.querySelectorAll('[data-align-frame]'), function (b) {
      b.addEventListener('click', function () { alignToFrame(b.getAttribute('data-align-frame')); });
    });
    el('ratioLockBtn').addEventListener('click', function () {
      state.ratioLocked = !state.ratioLocked;
      el('ratioLockBtn').style.background = state.ratioLocked ? '#000000' : '#FFFFFF';
      el('ratioLockBtn').style.color = state.ratioLocked ? '#FFFFFF' : '#000000';
    });
    el('posW').addEventListener('change', function (e) {
      var o = getActive(); if (!o) return;
      var newW = Math.max(4, parseFloat(e.target.value) || o.getScaledWidth());
      var curW = o.getScaledWidth();
      var scaleX = o.scaleX * (newW / curW);
      if (state.ratioLocked) o.set({ scaleX: scaleX, scaleY: o.scaleY * (newW / curW) }); else o.set({ scaleX: scaleX });
      o.setCoords(); fc.renderAll(); updatePositionFields(); pushHistory();
    });
    el('posH').addEventListener('change', function (e) {
      var o = getActive(); if (!o) return;
      var newH = Math.max(4, parseFloat(e.target.value) || o.getScaledHeight());
      var curH = o.getScaledHeight();
      var scaleY = o.scaleY * (newH / curH);
      if (state.ratioLocked) o.set({ scaleY: scaleY, scaleX: o.scaleX * (newH / curH) }); else o.set({ scaleY: scaleY });
      o.setCoords(); fc.renderAll(); updatePositionFields(); pushHistory();
    });
    el('posX').addEventListener('change', function (e) {
      var o = getActive(); if (!o) return;
      var F = frame(); var br = o.getBoundingRect(true);
      var targetLeft = F.frame.x + (parseFloat(e.target.value) || 0);
      o.left += targetLeft - br.left; o.setCoords(); fc.renderAll(); updatePositionFields(); pushHistory();
    });
    el('posY').addEventListener('change', function (e) {
      var o = getActive(); if (!o) return;
      var F = frame(); var br = o.getBoundingRect(true);
      var targetTop = F.frame.y + (parseFloat(e.target.value) || 0);
      o.top += targetTop - br.top; o.setCoords(); fc.renderAll(); updatePositionFields(); pushHistory();
    });
    el('posRotate').addEventListener('change', function (e) {
      var o = getActive(); if (!o) return;
      o.rotate(parseFloat(e.target.value) || 0); fc.renderAll(); updatePositionFields(); pushHistory();
    });

    el('contextMenuOverlay').addEventListener('click', closePopovers);

    document.addEventListener('click', function (e) {
      if (!el('colorPopover').contains(e.target) && e.target !== el('colorTrigger')) el('colorPopover').style.display = 'none';
      if (!el('alignPopover').contains(e.target) && e.target !== el('alignTrigger')) el('alignPopover').style.display = 'none';
      if (!el('positionPanel').contains(e.target) && e.target !== el('tPosition') && e.target !== el('iPosition')) el('positionPanel').style.display = 'none';
    });
  });
})();
